/**
 * BackgroundsRepository manages :
 * - used backgrounds
 * - recommended background (with same theme_category)
 * - search result backgrounds
 */
fx.ns("repositories", class BackgroundsRepository extends fx.ModelArray {

    constructor(model)
    {
        super([]);

        this._cacheTagsSearch = {};
        this._cache = {};
        this._nonExistingElements = {};
        
        this.endpoint = "/app/backgrounds";

        this._fromRecommended = 0;
        this._lastSearch = "";

        //this.internalSort = this._sortByPosition;

        this.set("backgroundsTag", new fx.ModelArray([]));
        this.set("defaults", new fx.ModelArray([]));
    }

    get recommended()
    {
        return this._recommendedBackgrounds;
    }

    get more()
    {
        if (this._lastSearch === "")
            return this._fromRecommended;
        else
            return this._fromSearch;
    }

    get bookid()
    {
        return this._bookid;
    }

    set bookid(val)
    {
        this._bookid = val;
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        this._themeid = val;
    }

    get categories()
    {
        return this._categories;
    }

    set categories(val)
    {
        this._categories = val;
    }

    get defaults()
    {
        return [];
    }
    
    init(data)
    {
        super.init([]);

        if (!this._recommendedBackgrounds)
        {
            this._recommendedBackgrounds = new fx.ModelArray();
            this._recommendedBackgrounds.parentModel = this;
        }

        this._fromRecommended = data.more;
        this._recommendedBackgrounds.init(data.data);
         
        this.addItem( this._recommendedBackgrounds, true );
    }


    loadRecommended(book)
    {
        if (this._fromRecommended === false)
            return;

        this.post(  { 
            action:"recommended", 
            themeid : book.themeid,
            bookid : book.id,
            theme_tag_id : this.themeTagId || undefined,
            from : this._fromRecommended,
            count : 30
        }, 
        this._loadRecommended);
    }

    /**
     * The theme tag the recommended ones come from, when it is not the one of the album's theme :
     * the album category detected by the automatic creation (BookRepository.applyAlbumCategory).
     */
    get themeTagId()
    {
        return this._themeTagId;
    }

    set themeTagId(val)
    {
        this._themeTagId = val;
    }

    /**
     * The recommended ones again, from that theme tag : those of the previous tag leave the panel,
     * unless the album uses them, and the list starts over.
     */
    reloadRecommended(book, themeTagId)
    {
        this.themeTagId = themeTagId;

        if (this._recommendedBackgrounds)
        {
            this.removeItems(this._recommendedBackgrounds.filter((item) => !(item.number > 0)));
            this._recommendedBackgrounds.removeAll(true);
        }

        this._fromRecommended = 0;
        this.loadRecommended(book);
    }

    _loadRecommended(data)
    {
        if (data.error)
            this.event("load-recommended-background-error")
        else
        {
            this._fromRecommended = data.more;
            this._recommendedBackgrounds.addItem(data.data, true);
            this.addItem(data.data, true);
            this.trigger("loaded");
        }
    }

    load( category_id, id_lang )
    {
        if (this._cache[category_id + "-" + id_lang ])
        {
            this.event("backgrounds-loaded", this);
            return;
        }
            

        this.post(  { 
            action:"load", 
            category_id : category_id,
            id_lang : id_lang
        }, 
        this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
            //this.event("server-error", data);
            this.event("load-backgrounds-server-error", data);
        else
        {
            if (data.length > 0)
            {
                this.addItem(data, false);
                this._cache[data[0].theme_category_id + "-" + data[0].id_lang] = data;
            }

            this.event("backgrounds-loaded", data);
        }
    }


    loadDefaults()
    {
        this.post(  { 
            action:"defaults",
        }, 
        this._loadedDefaults);
    }

    _loadedDefaults(data)
    {
        if (data.error)
            this.event("load-backgrounds-error", data);
        else
        {
            if (data.length > 0)
                this.backgroundsTag.addItem(data, false);

            this.event("default-backgrounds-loaded", data);
        }
    }

    loadDefaultTag(themetagid)
    {
        this.post(  { 
            action:"loaddefaults",
            theme_tag_id :themetagid
        }, 
        this._loadedDefaultTag);
    }

    _loadedDefaultTag(data)
    {
        if (data.error)
            this.event("load-backgrounds-error", data);
        else
        {
            this.defaults.removeAll(true);

            if (data.length > 0)
            {
                // add only new theme_tag_id & id
                for(let i = 0; i < data.length; i++)
                {
                    let background = data[i];
                    if (!this.defaults.find({id : background.id, theme_tag_id : background.theme_tag_id}))
                        this.defaults.addItem(background, false);    
                }
            }

            this.event("defaults-loaded", data);
        }
    }

    addThemeTag(background, themetag)
    {
        background.tags.addItem( themetag, true );

        let last = this.backgroundsTag.find({theme_tag_id : themetag.id}, true).length;
        
        let obj = this.backgroundsTag.find({theme_background_id : background.id, theme_tag_id : themetag.id});
        if (!obj)
            this.backgroundsTag.addItem( new models.ThemeBackgroundTag({theme_background_id : background.id, theme_tag_id : themetag.id, position : last}) );

        this.updateTagsPosition(themetag.id);
    }

    removeThemeTag(background, themetag)
    {
        let tag = background.tags.find({id : themetag.id});
        
        if (tag)
            background.tags.removeItem( tag );

        let currentBackground = this.find({ id : background.id});
        if (currentBackground)
        {
            let tag = currentBackground.tags.find({id : themetag.id});
        
            if (tag)
                currentBackground.tags.removeItem( tag );
        }

        let obj = this.backgroundsTag.find({theme_background_id : background.id, theme_tag_id : themetag.id});
        if (obj)
        {
            this.backgroundsTag.removeItem(obj);
            obj.delete();
        }

        let defaultBackground = this.defaults.find({id : background.id, theme_tag_id : background.theme_tag_id});
        if (defaultBackground)
            this.defaults.removeItem(defaultBackground);

        this.updateTagsPosition(themetag.id);
    }


    updateTagsPosition(themetagid)
    {
        let tags = this.backgroundsTag.find({theme_tag_id : themetagid}, true);
        tags.sort(function(a, b){ return a.position - b.position});
        for (let i = 0; i < tags.length; i++)
            tags.getItemAt(i).position = i;
    }


    addElement(id, obj)
    {
        if (obj)
            this.addItem( obj );
        else
            this._nonExistingElements[ id ] = true;;
    }

    notExisting(id)
    {
        return this._nonExistingElements[ id ]
    }
    

    /******************************* Tags ****************************/
    searchTags(search, callback)
    {
        if ( this._cacheTagsSearch[search] )
        {
            this._searchedTags(search, callback, this._cacheTagsSearch[search]);
        }
        else
        {
            this._searchedTagsHandler = this._searchedTags.bind(this, search, callback);
            this.post(  { 
                            action:"tags", 
                            search : search,
                            all : (fx.get("app") == "config") ? 1 : 0,
                            idlang : fx.service("LangService").current.id 
                        }, 
                        this._searchedTagsHandler);
        }
    }

    _searchedTags(search, callback, data)
    {
        let result = [];
        if (this._cacheTagsSearch[search])
            result = data;
        else
            for(let i = 0; i < data.length; i++)
                result.push({label : data[i]});
        
        this._searchedTagsHandler = null;
        this._cacheTagsSearch[search] = result;

        if (callback) callback(result);
    }

    /******************************* search ****************************/
    search(search, from)
    {
        if (!search)
        {
            this._fromSearch = false;
            this._lastSearch = "";
            this.removeAll(true);
            this.addItem(this._recommendedBackgrounds, true, false, false, true );

            this.trigger("loaded");
        }
        else
        {
        
            if (!from)
                this.removeAll(true);
            
            this._lastSearch = search;

            this.post(  { 
                            action:"search", 
                            search : search,
                            from : from,
                            all : (fx.get("app") == "config") ? 1 : 0,
                            idlang : fx.service("LangService").current.id 
                        }, 
                        this._searched);
        
        }
    }
    
    _searched(data)
    {
        if (!data.error)
        {
            // let's update number from existing ones
            for (let i = 0; i < data.data.length; i++)
            {
                let background = data.data[i];
                let bg = this._recommendedBackgrounds.find({id : background.id})
                if (bg)
                {
                    // let replace it
                    //background.number = bg.number;
                    data.data.splice(i, 1, bg);
                }
            }

            this._loading = false;

            this._fromSearch = data.more;

            this.addItem( data.data, true, false, false, true );

        }

        this.trigger("loaded");
    }

    // ------------ more
    loadMore(book)
    {
        if (this._loading) return;

        if (this._lastSearch === "")
        {
            this.loadRecommended(book);
        }
        else
        {
            //this._loadingMore = true;
            this.search(this._lastSearch, this._fromSearch);
        }
    }

    use(id, use, history)
    {
        let background = this.find({id : id});

        if (!background)
            return;

        //background.number = use ? (background.number + 1) : Math.max(1, background.number - 1);
        //background.update( {number : use ? (background.number + 1) : Math.max(1, background.number - 1)}, {history : !!history} );				
        if (use)
            background.use(history);
        else
            background.unuse(history);

        // case when a background from search is used
        // we add it to recommended (used and/or theme_category) backgrounds
        // we never remove it, because it could be a theme_category one
        if (use)
        {
            if (background.number > 0 )
            {
                if (!this._recommendedBackgrounds.find({id : id}))
                    this._recommendedBackgrounds.addItem(background);
            }
        }

        // to force grid to update
        this.trigger({type:"updated", action : new fx.Action("update", this, this, "", !!history)}); 
    }


    find(obj)
    {
        let background = super.find(obj);

        if (!background && this._lastSearch)
            background  = this._recommendedBackgrounds.find(obj)

        return background;
    }

    onDataEvent(e)
    {
        let background = e.model;

        if(e.type == "position-up")
        {
            let index = this.defaults.indexOf( background );
            if (index > 0)
            {
                let previousBackground = this.defaults.getItemAt( index - 1);
                let actualPosition = background.position;
                background.position = previousBackground.position;
                previousBackground.position = actualPosition;

                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down")
        {
            let index = this.defaults.indexOf( background );
            if (index < this.defaults.length-1)
            {
                let previousBackground = this.defaults.getItemAt( index + 1);
                let actualPosition = background.position;
                background.position = previousBackground.position;
                previousBackground.position = actualPosition;

                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-up-10")
        {
            let index = this.defaults.indexOf( background );
            if (index > 0)
            {
                let previousBackground = this.defaults.getItemAt( Math.max(0, index - 10));
                background.position = previousBackground.position - 0.5;
                
                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down-10")
        {
            let index = this.defaults.indexOf( background );
            if (index < this.defaults.length-1)
            {
                let previousBackground = this.defaults.getItemAt( Math.min( this.defaults.length-1, index + 10));
                background.position = previousBackground.position + 0.5;
                
                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-first")
        {
            let index = this.defaults.indexOf( background );
            if (index > 0)
            {
                let previousBackground = this.defaults.getItemAt( 0);
                background.position = previousBackground.position - 1;
                
                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-last")
        {
            let index = this.defaults.indexOf( background );
            if (index < this.defaults.length-1)
            {
                let previousBackground = this.defaults.getItemAt( this.defaults.length-1);
                background.position = previousBackground.position + 1;
                
                this.updateBackgroundPosition();
                this.event("position-updated");
            }
        }
    }

    updateBackgroundPosition()
    {
        this.defaults.sort(function(a, b){ return a.position - b.position});

        for (let i = 0; i < this.defaults.length; i++)
        {
            let background = this.defaults.getItemAt(i);
            background.position = i;

            let backgroundTag = this.backgroundsTag.find({ theme_tag_id : background.theme_tag_id, theme_background_id : background.id});
            backgroundTag.position = i;
        }

        this.sort(this._sortByPosition);
    }

    _sortByPosition(a, b)
    {
        if (a.position !== undefined && a.position !== undefined)
            return a.position - b.position;
        else
            return a.id - b.id;
    }
   
});